<template>
<div id="app_container">
    <vue-headful v-if="my_hotel&&my_hotel.id" :title="my_hotel.name" />

    <v-navigation-drawer class="im-nav" v-model="drawer" clipped :mini-variant.sync="miniVariant" app overflow>
        <im-drawer :hotel="my_hotel" :admin="admin" :miniVariant="miniVariant" />
    </v-navigation-drawer>

    <v-app-bar clipped-left app color="topbar" height="48px">
        <v-app-bar-nav-icon>
            <v-avatar dark tile size="28" @click="openMenu($vuetify.breakpoint.lgAndUp)">
                <img :src="juvo_logo" alt="" height="28px" width="auto">
            </v-avatar>
        </v-app-bar-nav-icon>

        <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp" class="major white--text">Console</v-toolbar-title>
        <!-- hotel selection -->
        <im-hotel-selection :hotel="my_hotel" @changeHotel="changeMyHotel($event)" />
        <!-- ./ hotel selection -->

        <v-spacer></v-spacer>

        <v-toolbar-items>
            <im-language-selector :use="['en', 'ro']" select="ro" @input="changeLocale($event)" />
            <im-profile />
        </v-toolbar-items>
    </v-app-bar>

    <!-- content -->
    <v-content>
        <router-view :hotel="my_hotel" @changeHotel="redirectMyhotel($event)" @refresh="getMyHotel($event)" />
    </v-content>
    <!-- ./ content -->
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import storage from '../../storage';
import logger from "../../logger.js";
import juvo_logo from '../../assets/juvo-app-icon.svg';
import hotjar from '../../hotjar.js';
import IMAppSelector from '@imemento/spa-helpers/src/components/IMAppSelector/IMAppSelector.vue';
import IMProfile from '@imemento/spa-helpers/src/components/IMProfile/IMProfile.vue';
import IMLanguageSelector from '@imemento/spa-helpers/src/components/IMLanguageSelector/IMLanguageSelector.vue';
import IMDrawer from '../../components/items/App/Drawer.vue';
import IMHotelSelection from '../../components/items/App/HotelSelection.vue';

export default {
    components: {
        'im-app-selector': IMAppSelector,
        'im-profile': IMProfile,
        'im-language-selector': IMLanguageSelector,
        'im-drawer': IMDrawer,
        'im-hotel-selection': IMHotelSelection,
    },

    name: 'App',

    data() {
        return {
            admin: false,
            clipped: false,
            drawer: true,
            fixed: false,
            menu: false,
            miniVariant: false,
            right: true,

            //hotel selection
            loading_hotels: false,
            user_id: null,
            my_hotel: this.defaultHotel(),
            juvo_logo: juvo_logo
        }
    },

    watch: {
        'my_hotel.slug': {
            async handler(newValue, oldValue) {
                await this.my_hotel
                if(newValue !== undefined && oldValue !== undefined) {
                    this.$router.replace({
                        params: {
                            hotel_slug: newValue
                        }
                    });
                }
            },
            deep: true
        },

    },

    async mounted() {
        let roles = await storage.getRoles();
        this.admin = (roles.ssr_console.includes('admin'));
        if(process.env.NODE_ENV === 'production' && !roles.ssr_console.includes('admin')) {
            (function (h, o, t, j, a, r) {
                h.hj = h.hj || function () {
                    (h.hj.q = h.hj.q || [])
                    .push(arguments)
                };
                h._hjSettings = {
                    hjid: 1512199,
                    hjsv: 6
                };
                a = o.getElementsByTagName('head')[0];
                r = o.createElement('script');
                r.async = 1;
                r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
                a.appendChild(r);
            })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
        }
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        async defaultHotel() {
            try {
                let hotel = JSON.parse(localStorage.getItem('hotel'));
                true && hotel.slug;
                this.my_hotel = await this.getDataHotel(hotel.id);
            } catch (error) {
                localStorage.removeItem('hotel');
                this.my_hotel = await this.setDataDefaultHotel();
            }
        },

        getDataHotel(hotel_id) {
            if(hotel_id) {
                // setup query endpoint
                let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
                let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/" + hotel_id;

                return this.$axios.get(endpoint)
                    .then(response => {
                        let hotel = {
                            'city': response.data.static.geo.city,
                            'currency': response.data.static.defaults.currency,
                            'county': {
                                'code': response.data.country_code,
                                'name': null,
                            },
                            'context': response.data.context,
                            'email': response.data.email,
                            'name': response.data.name,
                            'id': response.data.id,
                            'old_id': response.data.old_id,
                            'org_id': response.data.org_id,
                            'image': response.data.static.images[0] ? response.data.static.images[0] : null,
                            'language': response.data.language,
                            'status': response.data.status,
                            'slug': response.data.slug,
                            'weekend': response.data.static.defaults.weekend,
                        }
                        return hotel
                    })
                    .catch(error => {
                        console.log(error);
                        if(error.response.data.error.code == 403) {
                            this.error(this.$t('app.message_error_no_hotel_accesss'));
                            this.$router.push({
                                path: '/dashboard'
                            });
                            return this.setDataDefaultHotel()
                        } else {
                            this.error("Oops, something went wrong!");
                        }
                        return {}
                    })
                    .finally(() => {});
            }

        },

        setDataDefaultHotel() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/hotels';

            // setup query params
            let params = {
                params: {
                    size: 5,
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.data[0]) {
                        localStorage.setItem('hotel', JSON.stringify(response.data.data[0]));
                        return response.data.data[0];
                    } else {
                        return {}
                    }
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                    return {}
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        redirectMyhotel(value) {
            this.getMyHotel(value[0]);
            if(value[1]) {
                this.$router.push({
                    path: '/' + this.my_hotel.slug + '/inventory-pricing'
                });
            }
        },

        changeMyHotel(value) {
            if(typeof value == 'undefined')
                return;
            this.my_hotel = this.$clone(value);
            // update hotel localStorage
            localStorage.setItem('hotel', JSON.stringify(value));
        },

        openMenu(value) {
            if(value === true) {
                this.miniVariant = !this.miniVariant;
            } else {
                this.miniVariant = false;
                this.drawer = !this.drawer;
            }
        },

        getMyHotel(hotel_id) {
            if(hotel_id) {
                // setup query endpoint
                let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
                let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/" + hotel_id;
                return this.$axios.get(endpoint)
                    .then(response => {
                        let hotel = {
                            'city': response.data.static.geo.city,
                            'currency': response.data.static.defaults.currency,
                            'context': response.data.context,
                            'email': response.data.email,
                            'name': response.data.name,
                            'id': response.data.id,
                            'language': response.data.language,
                            'status': response.data.status,
                            'slug': response.data.slug,
                            'weekend': response.data.static.defaults.weekend,
                        }
                        this.my_hotel = this.$clone(hotel);
                        // update hotel localStorage
                        localStorage.setItem('hotel', JSON.stringify(hotel));
                        // this.changeMyHotel(hotel);
                        return new Promise(function (resolve, reject) {
                            resolve(true);
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        if(error.response.data.error.code == 403) {
                            this.error(this.$t('app.message_error_no_hotel_accesss'));
                            this.$router.push({
                                path: '/dashboard'
                            });
                        } else {
                            this.error("Oops, something went wrong!");
                        }
                    })
            }
        },

        changeLocale(locale) {
            this.$i18n.locale = locale;
            this.$vuetify.lang.current = locale;
        },

    },

}
</script>
<style lang="stylus">
.badge-new
    position: absolute
    right: 0
    top: 0
    background-color: #39DA8A
    color: white
    border-radius: 15px
    padding: 2px 6px
.hotel-title
    &.v-btn
        font-size: 24px
        font-weight: 700
        left: 140px
        @media only screen and (max-width: 700px)
            font-size: 18px
            font-weight: 700
            left: 0
        @media only screen and (max-width: 450px)
            span
                max-width: 140px
                white-space: nowrap !important
                overflow: hidden !important
                text-overflow: ellipsis !important
                line-height: 1.1 !important
.hotel-name
    font-size: 16px
    font-weight: 300
    color: black
    text-align: center

.topbar-menu-list
    &.v-menu__content
        overflow-x: initial
        overflow-y: initial
.search-results
    .v-select
        .v-select__slot
            .v-select__selections
                input
                    padding-left: 15px
.handle
    cursor: grab
    
.icon-rotate
    -moz-transition: all 1s linear
    -webkit-transition: all 1s linear
    transition: all 1s linear
    &.rotation-active
        -moz-transform:rotate(180deg)
        -webkit-transform:rotate(180deg)
        transform:rotate(180deg)

.group-btn
    &.v-btn-toggle--selected
        box-shadow: none
    &.v-item-group
        .v-btn
            width: 75px
            align-self: center
            .v-btn__content
                color: white
            &.v-btn--active
                font-size: 14px
                height: 36px
            &:hover
                font-size: 14px
                height: 36px
                transition-property: height
                transition-duration: 0.2s
                transition-timing-function: ease-in-out
</style>
